module.exports = __webpack_public_path__ + "img/index-logo.c0bd07a6.jpg";